import { Button } from '@alifd/next';
import { Image, Modal } from 'antd'; //dialog UI
import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

import Carousel from '@/components/UI/Carousel';

import ezconImg from '../../../../public/ezcon.png';
import client from '../../../lib/feathers';
import MobileHomeHotMessage from '../components/MobileHomeHotMessage';
import MobileHomeHotMessageLimit2 from '../components/MobileHomeHotMessageLimit2';
import MobileHomeWeather from '../components/MobileHomeWeather';
import styles from './MobileHomeBanner.module.scss';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const previewModalBodyStyle = {
  padding: 0,
  maxHeight: '95dvh',
};

const MobileHomeBanner = () => {
  const FileViewer = React.lazy(() => {
    return import('react-file-viewer');
  });
  const announcement = client.service('announcement');
  const postalRegistration = client.service('postalRegistration');
  const communityData = client.service('communityData');
  const [dateTime, setDateTime] = useState(new Date());
  const [announcementArr, setAnnouncementArr] = useState([]);
  const [communityDataArr, setCommunityDataArr] = useState([]);
  const [postalArr, setPostalArr] = useState([]);
  const [previewDialog, setPreviewDialog] = useState(false);
  const [numPages, setNumPages] = useState(null);
  const [file, setFile] = useState({
    showPath: '/ezcon/doc/EZ社區APP v1.pdf',
    oldName: '/ezcon/doc/EZ社區APP v1.pdf',
    png: [
      '/ezcon/img/communityData/1673322404670-6858-0.png',
      '/ezcon/img/communityData/1673322404670-6858-1.png',
      '/ezcon/img/communityData/1673322404670-6858-2.png',
      '/ezcon/img/communityData/1673322404670-6858-3.png',
      '/ezcon/img/communityData/1673322404670-6858-4.png',
      '/ezcon/img/communityData/1673322404670-6858-5.png',
      '/ezcon/img/communityData/1673322404670-6858-6.png',
      '/ezcon/img/communityData/1673322404670-6858-7.png',
      '/ezcon/img/communityData/1673322404670-6858-8.png',
      '/ezcon/img/communityData/1673322404670-6858-9.png',
      '/ezcon/img/communityData/1673322404670-6858-10.png',
      '/ezcon/img/communityData/1673322404670-6858-11.png',
      '/ezcon/img/communityData/1673322404670-6858-12.png',
      '/ezcon/img/communityData/1673322404670-6858-13.png',
      '/ezcon/img/communityData/1673322404670-6858-14.png',
      '/ezcon/img/communityData/1673322404670-6858-15.png',
      '/ezcon/img/communityData/1673322404670-6858-16.png',
      '/ezcon/img/communityData/1673322404670-6858-17.png',
      '/ezcon/img/communityData/1673322404670-6858-18.png',
      '/ezcon/img/communityData/1673322404670-6858-19.png',
      '/ezcon/img/communityData/1673322404670-6858-20.png',
      '/ezcon/img/communityData/1673322404670-6858-21.png',
    ],
  });
  const [fileViewerType, setFileViewerType] = useState('');
  const [fileViewerPath, setFileViewerPath] = useState('');
  const [fileViewerKey, setFileViewerKey] = useState('');
  const [loading, setLoading] = useState('');
  const [visible, setVisible] = useState('');
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentTime, setCurrentTime] = useState('');

  useEffect(() => {
    client
      .reAuthenticate()
      .then((data) => {
        postalRegistration
          .find({
            query: {
              household: data.user.householdNumbers[0],
              $limit: 1,
              $sort: {
                createdTime: -1,
              },
            },
          })
          .then((res) => {
            console.log(
              '==homepage find postalRegistration  data success:',
              res.data
            );
            const displayPostalData = res.data.filter(
              (postal) =>
                postal.status === '未領取' &&
                (!postal.recipient ||
                  postal.userObjectId === data.user._id ||
                  postal.recipient === data.user.name)
            );
            setPostalArr(displayPostalData);
          })
          .catch((error) => {
            console.log(
              '==homepage  find  postalRegistration data fail:',
              error
            );
          });
        console.log('==re login mobile home banner ok', data);
      })
      .catch((err) => {
        console.log('==re login mobile home banner   fail', err);
      });
  }, [postalRegistration]);

  const BasicDate = {
    imgTitle: '平台操作手冊',
    imgContent: '提供住戶教學手冊，可供下載。',
    buttons: () => {
      return [...new Array(11)].map((_i, nb) => {
        return (
          <div key={nb} className={styles.flex}>
            <img src="/ezcon/ezcon_logo.png" alt="" />
            <span className={styles.infoText}>NEW</span>
            <span className={styles.btn}>按鈕{nb}</span>
          </div>
        );
      });
    },
  };

  useEffect(() => {
    const id = setInterval(() => setDateTime(new Date()), 1000);
    return () => {
      clearInterval(id);
    };
  }, []);

  const updateData = useCallback(
    function () {
      announcement
        .find({
          query: {
            type: '一般公告',
            $limit: 1,
            $sort: {
              createdTime: -1,
            },
          },
        })
        .then((res) => {
          console.log('==homepage  find  announcement data success:', res.data);
          setAnnouncementArr(res.data);
        })
        .catch((error) => {
          console.log('==homepage  find  announcement data fail:', error);
        });
      communityData
        .find({})
        .then((res) => {
          console.log(
            '==homepage  find  communityData data success:',
            res.data
          );
          setCommunityDataArr(res.data);
        })
        .catch((error) => {
          console.log('==homepage  find  communityData data fail:', error);
        });
    },
    [announcement, communityData]
  );
  useEffect(() => {
    updateData();
  }, [updateData]);

  useEffect(() => {
    setCurrentTime(moment().format('HH:mm'));
  }, [dateTime]);

  const chineseWeekDay = () => {
    let day = '星期';
    switch (new Date().getDay()) {
      case 0:
        day = day + '日';
        break;
      case 1:
        day = day + '一';
        break;
      case 2:
        day = day + '二';
        break;
      case 3:
        day = day + '三';
        break;
      case 4:
        day = day + '四';
        break;
      case 5:
        day = day + '五';
        break;
      case 6:
        day = day + '六';
    }
    return day;
  };

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  const onError = (e) => {
    console.log(e, 'error in file-viewer');
  };

  useEffect(() => {
    const getManual = async () => {
      try {
        const communityData = (await client.service('communityData').find({}))
          .data[0];
        const manual = communityData?.residentialManual[0]?.response;

        console.log({ communityData, manual });
        // if (manual) {
        if (manual) {
          setFile(manual);
        }
        // }
      } catch (error) {
        console.error(error);
      }
    };
    getManual();
  }, []);

  const handleImageClick = (imageIndex) => {
    setCurrentImageIndex(imageIndex);
    setIsPreviewModalOpen(true);
  };

  return (
    <>
      <Modal
        mask={false}
        className={styles.modal1}
        open={previewDialog}
        footer={null}
        onCancel={() => {
          setPreviewDialog(false);
          setFileViewerPath('');
          setFileViewerType('');
        }}
      >
        <div className={styles.previewFileContainer}>
          <a
            className={styles.download}
            target="_blank"
            rel="noreferrer"
            download={file.oldName}
            href={file.showPath}
          >
            下載
          </a>
          <div key={fileViewerKey} className={styles.documentBlock}>
            {file?.png.map((item, index) => (
              <Image
                preview={{
                  visible: false,
                }}
                onClick={() => handleImageClick(index)}
                src={item}
                key={index}
              />
            ))}
            <Modal
              open={isPreviewModalOpen}
              footer={null}
              centered
              bodyStyle={previewModalBodyStyle}
              width="auto"
              onCancel={() => setIsPreviewModalOpen(false)}
            >
              <Carousel images={file?.png} slideNumber={currentImageIndex} />
            </Modal>
          </div>
        </div>
      </Modal>

      <div className={styles.banner}>
        <p className={styles.timeYearPhone}>
          {moment(dateTime).format('YYYY-MM-DD')} {chineseWeekDay()}
        </p>
        <div
          className={styles.imgSlider}
          onClick={() => {
            setPreviewDialog(true);
          }}
        >
          <div>
            <img
              className={styles.img}
              src={
                communityDataArr[0]?.files
                  ? `${communityDataArr[0].files.path}`
                  : ezconImg
              }
              alt=""
            />
            {/* <img src={`img/操作手冊.png`} alt="" /> */}
            <div className={styles.imgText}>
              <p className={styles.title}>{BasicDate.imgTitle}</p>
              <p className={styles.content}>{BasicDate.imgContent}</p>
            </div>
          </div>
        </div>
        <div className={styles.timeText}>
          <div className={styles.timeWord}>
            <p className={styles.timeYear}>
              {moment(dateTime).format('MM/DD')} {chineseWeekDay()}
            </p>
            <div className={styles.timeHour}>
              {currentTime}
              <span className={styles.time}>
                {new Date().getHours() >= 12 ? 'PM' : 'AM'}
              </span>
            </div>

            <div className={styles.weatherIconLine}></div>
            <MobileHomeWeather />
          </div>

          <div className={styles.hotMessage}>
            <p className={styles.hotText}>熱門訊息</p>
            {announcementArr.map((item, index) => (
              <MobileHomeHotMessage
                key={index}
                createdTime={item.createdTime}
                type={item.type}
                title={item.title}
                content={item.content}
              />
            ))}
            {postalArr.map((item, index) => (
              <MobileHomeHotMessageLimit2
                key={index}
                placement={item.placement}
                packagerRegistrationTime={item.packagerRegistrationTime}
                packageType={item.packageType}
                information={item.information}
                vendor={item.vendor}
                logistics={item.logistics}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileHomeBanner;
